export const PROPERTY_TYPE_ALL = 'property_type_all';

export const PROPERTY_TYPES = [
    'property_type_apartment',
    'property_type_barn',
    'property_type_boat',
    'property_type_bungalow',
    'property_type_cabin',
    'property_type_caravane',
    'property_type_castle',
    'property_type_chalet',
    'property_type_chambre',
    'property_type_chateau',
    'property_type_condo',
    'property_type_cottage',
    'property_type_countryhouse',
    'property_type_estate',
    'property_type_farmhouse',
    'property_type_house',
    'property_type_houseboat',
    'property_type_lodge',
    'property_type_mill',
    'property_type_mobile_home',
    'property_type_resort',
    'property_type_studio',
    'property_type_suite',
    'property_type_tower',
    'property_type_townhome',
    'property_type_villa',
    'property_type_yacht'
];

export function isPropertyTypeAll(propertyType) {
    return propertyType === PROPERTY_TYPE_ALL;
}
